module.exports = __webpack_public_path__ + "img/Impact identification-Impact interaction.216d41a8.svg";